import { useEffect } from 'react';
/**
 * Widgets that use the arrow keys themselves, e.g. an open menu or a select, keep them.
 */
const ARROW_KEY_WIDGETS = [
    'input',
    'textarea',
    'select',
    '[contenteditable]:not([contenteditable="false"])',
    '[aria-expanded="true"]',
    '[role="menu"]',
    '[role="listbox"]',
    '[role="combobox"]',
    '[role="grid"]',
    '[role="tree"]',
    '[role="tablist"]',
    '[role="radiogroup"]',
    '[role="slider"]',
    '[role="spinbutton"]',
].join(',');
const isArrowKeyWidget = (target) => target instanceof Element && Boolean(target.closest(ARROW_KEY_WIDGETS));
/**
 * Navigate to the previous/next document with the up/down arrow keys while the preview is open.
 *
 * The listener runs in the capture phase and stops the event, since the focus often stays on the
 * closed menu trigger that opened the preview, which would otherwise open its menu on arrow down.
 */
export const useDocumentPreviewKeyboardNavigation = (options) => {
    const { enabled, onPrevious, onNext } = options;
    useEffect(() => {
        if (!enabled) {
            return undefined;
        }
        const handleKeyDown = (event) => {
            const hasModifier = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
            const isNavigationKey = event.key === 'ArrowUp' || event.key === 'ArrowDown';
            if (!isNavigationKey || event.defaultPrevented || hasModifier || isArrowKeyWidget(event.target)) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            if (event.key === 'ArrowUp') {
                onPrevious();
            }
            else {
                onNext();
            }
        };
        document.addEventListener('keydown', handleKeyDown, { capture: true });
        return () => document.removeEventListener('keydown', handleKeyDown, { capture: true });
    }, [enabled, onPrevious, onNext]);
};
